import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import {
    getCategoryDepthLoaded as actualGetCategoryDepthLoaded,
    getCategoryState,
} from "@insite/client-framework/Store/Data/Categories/CategoriesSelectors";
import loadCategory from "@insite/client-framework/Store/Data/Categories/Handlers/LoadCategory";
import { getPageLinkByNodeId } from "@insite/client-framework/Store/Links/LinksSelectors";
import { HasLinksState } from "@insite/client-framework/Store/Links/LinksState";
import { LinkFieldValue } from "@insite/client-framework/Types/FieldDefinition";
import { useDispatch } from "react-redux";

export interface StoreLinkFields {
    destination: LinkFieldValue;
    title?: string;
}

export const getLinkStore = (state: ApplicationState, fields: StoreLinkFields) => {
    const category =
        fields.destination.type === "Category" ? getCategoryState(state, fields.destination.value).value : null;
    switch (fields.destination.type) {
        case "Page":
            return getPageLinkByNodeId(state, fields.destination.value);
        case "Category":
            return {
                url: category?.path,
                title: category?.shortDescription,
            };
        case "Url":
            return {
                url: fields.destination.value,
                title: fields.title || fields.destination.value,
            };
    }
};

export const useGetLinks = <T>(list: T[], linkSelector: (item: T) => LinkFieldValue) => {
    const linkFields = list.map(linkSelector);

    const links = useAppSelector(state =>
        list.map((o: any) => {
            const link = getLinkStore(state, o.fields);
            return !link ? { url: undefined, title: undefined } : link;
        }),
    );

    const categoryStates = useAppSelector(state =>
        linkFields.map(linkField => {
            if (linkField.type !== "Category") {
                return;
            }

            return getCategoryState(state, linkField.value);
        }),
    );

    const dispatch = useDispatch();

    for (let x = 0; x < links.length; x++) {
        const linkField = linkFields[x];
        const link = links[x];
        const categoryState = categoryStates[x];

        if (
            linkField.type === "Category" &&
            linkField.value &&
            !link.url &&
            !categoryState?.isLoading &&
            !categoryState?.errorStatusCode
        ) {
            dispatch(loadCategory({ id: linkField.value }));
        }
    }

    return links;
};
